/**
 * Tokens, types, and ChartConfig shared by the nutrition pie charts.
 *
 * Kept in a separate (non-tsx) module from `nutrition-charts.tsx` so React
 * Fast Refresh can hot-reload the components without invalidation. See:
 * https://github.com/vitejs/vite-plugin-react/discussions/167
 */
import type { ChartConfig } from "@/components/ui/chart";

export const NUTRITION_COLORS = {
  energy: "var(--nutrition-energy)",
  carbs: "var(--nutrition-carbs)",
  protein: "var(--nutrition-protein)",
  fiber: "var(--nutrition-fiber)",
  fats: "var(--nutrition-fats)",
  bmr: "var(--nutrition-bmr)",
  activity: "var(--nutrition-activity)",
  remaining: "var(--nutrition-remaining)",
  consumed: "var(--nutrition-consumed)",
} as const;

export const NUTRITION_CHART_CONFIG = {
  value: { label: "kcal" },
  energy: { label: "Energy", color: NUTRITION_COLORS.energy },
  carbs: { label: "Carbs", color: NUTRITION_COLORS.carbs },
  protein: { label: "Protein", color: NUTRITION_COLORS.protein },
  fiber: { label: "Fiber", color: NUTRITION_COLORS.fiber },
  fats: { label: "Fats", color: NUTRITION_COLORS.fats },
  bmr: { label: "BMR", color: NUTRITION_COLORS.bmr },
  activity: { label: "Activity", color: NUTRITION_COLORS.activity },
  remaining: { label: "Remaining", color: NUTRITION_COLORS.remaining },
  consumed: { label: "Consumed", color: NUTRITION_COLORS.consumed },
  empty: { label: "Empty", color: "oklch(var(--muted))" },
} satisfies ChartConfig;

export type NutritionSegmentKey = Exclude<
  keyof typeof NUTRITION_CHART_CONFIG,
  "value"
>;

export interface NutrientPieSegment {
  key: NutritionSegmentKey;
  value: number;
}
